import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const videoUrl = 'https://cdn.magicpatterns.com/uploads/gyvBbRyEvGMSpU1NUyMkb4/Alisado%20Progresivo%20Org%C3%A1nico%20%F0%9F%92%ABTurnitos%20disponibles%20para%20Agosto%20%F0%9F%92%98.mp4';
const imageUrl = 'https://cdn.magicpatterns.com/uploads/pHv8wF6LpQv7Z2xMVNzBno/Alisado_Progresivo_Organico_💫Turnitos_disponibles_para_Agosto_💘.jpg';
export function HairGallery() {
  return <section id="hair-gallery" className="w-full py-20 px-4 bg-pink/20" data-id="element-51">
      <div className="max-w-6xl mx-auto" data-id="element-52">
        <div className="text-center mb-16" data-id="element-53">
          <p className="text-gold font-semibold tracking-widest uppercase text-sm mb-3" data-id="element-54">
            Alisados & Tratamientos
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-charcoal mb-4" data-id="element-55">
            Galería de Cabello
          </h2>
          <p className="text-charcoal/70 max-w-2xl mx-auto" data-id="element-56">
            Resultados increíbles con nuestros alisados progresivos y
            tratamientos nutritivos
          </p>
          <div className="flex items-center justify-center gap-4 mt-6" data-id="element-57">
            <div className="w-16 h-0.5 bg-gold" data-id="element-58" />
            <div className="w-2 h-2 bg-gold rotate-45" data-id="element-59" />
            <div className="w-16 h-0.5 bg-gold" data-id="element-60" />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-61">
          {/* Video Player */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative aspect-square md:aspect-[4/5] overflow-hidden rounded-2xl shadow-lg shadow-pink/30 group" data-id="element-62">
            <video src={videoUrl} autoPlay loop muted playsInline className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-63" />
            <div className="absolute inset-0 bg-gradient-to-t from-charcoal/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" data-id="element-64" />
          </motion.div>

          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative aspect-square md:aspect-[4/5] overflow-hidden rounded-2xl shadow-lg shadow-pink/30 group" data-id="element-65">
            <img src={imageUrl} alt="Resultado de alisado progresivo" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" data-id="element-66" />
            <div className="absolute inset-0 bg-gradient-to-t from-charcoal/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" data-id="element-67" />
          </motion.div>
        </div>

        <div className="text-center mt-12" data-id="element-68">
          <a href="https://vrbeautystudio.koob.uy" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-8 py-4 bg-gold text-white font-semibold rounded-full hover:bg-gold/90 transition-colors shadow-lg hover:shadow-xl" data-id="element-69">
            Reservar turno
            <ArrowRight className="w-4 h-4" data-id="element-70" />
          </a>
        </div>
      </div>
    </section>;
}